<getm-swipe-actions
  #swipeActions
  [actions]="actions"
  (editClick)="onEditItem()"
  (deleteClick)="onDeleteItem()"
>
  <ion-grid class="promo-item">
    <!-- Fila 1: Imagen + Info + Derecha (kebab / precios) -->
    <ion-row class="promo-item__main-row">
      <ion-col size="3" class="promo-item__images">
        <ion-thumbnail class="promo-item__img">
          <ion-img [src]="'Icons.generic-promo-v2' | translate"></ion-img>
        </ion-thumbnail>
      </ion-col>

      <ion-col class="promo-item__info">
        <ion-text
          class="promo-item__name getm-ellipsis-three"
          color="getm-neutral-dark"
        >
          {{ promo.Promocion }}
        </ion-text>
        <ng-container *ngIf="promo.Bonificacion && ID_Programa === 4">
          <getm-tag-card-product
            class="promo-item__recompepsi-tag"
            icon="getm-recompepsi"
            [label]="'Labels.recompepsi' | translate"
            color="getm-category-promociones-light"
            corners="full"
          ></getm-tag-card-product>
        </ng-container>
      </ion-col>

      <ion-col size="auto" class="promo-item__right">
        <ion-row class="promo-item__top-row">
          <ng-container *ngIf="isOrderActive">
            <ion-label *ngIf="promo.isNew" class="promo-item__status-badge">
              {{ 'Labels.new' | translate }}
            </ion-label>
            <ion-label
              *ngIf="promo.isEdit && promo.newAdd !== 0"
              class="promo-item__status-badge"
            >
              {{ promo.newAdd > 0 ? '+' + promo.newAdd : promo.newAdd }}
            </ion-label>
          </ng-container>

          <ng-container *ngIf="actions.length > 0">
            <ion-button
              fill="clear"
              size="small"
              class="promo-item__kebab"
              (click)="openOptions()"
            >
              <ion-icon
                name="ellipsis-vertical"
                slot="icon-only"
                color="getm-primary-default"
              ></ion-icon>
            </ion-button>
          </ng-container>
        </ion-row>

        <ion-text class="promo-item__unit-price" color="getm-neutral-light">
          <del>
            {{
              (productosTotales | summaryPrice : promo.PaquetesCanjeados : true)
                .total_precio | currency : undefined : 'symbol' : '1.2-2'
            }}
          </del>
          {{ 'Labels.each-one' | translate }}
        </ion-text>

        <ion-text class="promo-item__total-price" color="getm-neutral-dark">
          {{
            (productosTotales | summaryPrice : 1 : false).total_precio_descuento
              | currency : undefined : 'symbol' : '1.2-2'
          }}
        </ion-text>
      </ion-col>
    </ion-row>

    <!-- Fila 2: Toggle de detalle + selector de cantidad -->
    <ion-row
      class="promo-item__actions-row ion-align-items-center ion-justify-content-between"
    >
      <ng-container *ngIf="!promo.CartAuto">
        <ion-col size="auto">
          <getm-button
            color="link"
            [text]="'Labels.detail' | translate"
            [icon]="isExpanded ? 'chevron-up' : 'chevron-down'"
            iconSlot="end"
            (btnClick)="toggleDetail()"
          ></getm-button>
        </ion-col>
        <ion-col size="auto">
          <ng-container
            *ngIf="promo.TipoPromocion === 'ESTATICO'; else promoCount"
          >
            <getm-quantity-selector
              [quantity]="promo.PaquetesCanjeados || 1"
              [minimo]="1"
              [maximo]="promo.MaximoPaquetes || 1"
              fill="outline"
              (quantityChange)="onQuantityChange($event)"
              (removeProduct)="onDeleteItem()"
            ></getm-quantity-selector>
          </ng-container>
          <ng-template #promoCount>
            <ng-container *ngIf="promo.TipoPromocion !== 'BONIFICACION'">
              <ion-label
                class="promo-item__promo-count ion-text-end"
                color="getm-neutral-dark"
              >
                {{ promo.PaquetesCanjeados }} {{ 'Labels.promo-s' | translate }}
              </ion-label>
            </ng-container>
          </ng-template>
        </ion-col>
      </ng-container>
    </ion-row>

    <!-- Fila 3: Detalle expandible (ancho completo) -->
    <ion-row class="promo-item__detail-row">
      <ion-col>
        <section
          [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'"
          class="promo-item__detail-content"
        >
          <ion-grid class="promo-item__detail-inner">
            <!-- Sección: productos con descuento -->
            <ng-container *ngIf="discountedProducts.length > 0">
              <ion-text class="promo-item__table-title">{{
                'Labels.discounted-products' | translate
              }}</ion-text>
              <ion-row class="promo-item__table-header">
                <ion-col size="2">
                  <ion-label>
                    {{ 'Labels.packages' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="3">
                  <ion-label>
                    {{ 'Labels.regular-price' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="3">
                  <ion-label>
                    {{ 'Labels.savings' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="4">
                  <ion-label>
                    {{ 'Labels.total' | translate }}
                  </ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="promo-item__table-data">
                <ion-col size="2">
                  <ion-text color="getm-neutral-dark">
                    {{
                      (
                        discountedProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_productos
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="3">
                  <ion-text color="getm-disabled-default">
                    {{
                      (
                        discountedProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_precio | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="3">
                  <ion-text color="getm-secondary-default">
                    -{{
                      (
                        discountedProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_descuento
                        | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="4">
                  <ion-text color="getm-neutral-dark">
                    {{
                      (
                        discountedProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_precio_descuento
                        | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </ion-text>
                </ion-col>
              </ion-row>
            </ng-container>

            <!-- Sección: productos sin descuento -->
            <ng-container *ngIf="regularProducts.length > 0">
              <ion-text class="promo-item__table-title">{{
                'Labels.regular-products' | translate
              }}</ion-text>
              <ion-row class="promo-item__table-header">
                <ion-col size="2">
                  <ion-label>
                    {{ 'Labels.packages' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="3">
                  <ion-label>
                    {{ 'Labels.regular-price' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="3">
                  <ion-label>
                    {{ 'Labels.savings' | translate }}
                  </ion-label>
                </ion-col>
                <ion-col size="4">
                  <ion-label>
                    {{ 'Labels.total' | translate }}
                  </ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="promo-item__table-data">
                <ion-col size="2">
                  <ion-text color="getm-neutral-dark">
                    {{
                      (
                        regularProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_productos
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="3">
                  <ion-text color="getm-disabled-default">
                    {{
                      (
                        regularProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_precio | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="3">
                  <ion-text color="getm-disabled-light">$0.00</ion-text>
                </ion-col>
                <ion-col size="4">
                  <ion-text color="getm-neutral-dark">
                    {{
                      (
                        regularProducts
                        | summaryPrice : promo.PaquetesCanjeados : true
                      ).total_precio | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </ion-text>
                </ion-col>
              </ion-row>
            </ng-container>
          </ion-grid>
        </section>
      </ion-col>
    </ion-row>
  </ion-grid>
</getm-swipe-actions>
